import style from '#src/client/members/common/layout/PageTitle.module.css';

function PageTitle(props) {
    return (
        <h1 class={style.pageTitle}>{props.children}</h1>
    );
}

export default PageTitle;
